<template>
    <div v-if="editOne.uuid == uuid">
        <el-form :model="nowData" ref="nowData" class="nowData" :inline="true">
            <el-form-item label="名称">
                <el-input v-model="nowData.title" style="width: 550px"></el-input>
            </el-form-item>

            <el-form-item>
                <el-checkbox v-model="nowData.require">必填</el-checkbox>
            </el-form-item>
            <el-form-item>
                <span style="color: #606266;font-size: 14px;text-decoration: underline;cursor: pointer;" @click.stop="dialogTip = true">
                    填写提示
                </span>
            </el-form-item>

            <div style="margin-left: 10px">
                <el-form-item label="类型">
                    <el-select v-model="nowData.type" placeholder="请选择类型">
                        <el-option label="输入框" value="input"></el-option>
                        <el-option label="单选" value="radio"></el-option>
                        <el-option label="多选" value="checkBox"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="数据" v-show="nowData.type!='input'">
                    <el-tag :key="tag" v-for="tag in dynamicTags" closable :disable-transitions="false" @close="handleClose(tag)">
                        {{tag}}
                    </el-tag>
                    <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="small" @keyup.enter.native="handleInputConfirm"
                        @blur="handleInputConfirm">
                    </el-input>
                    <el-button v-else class="button-new-tag" size="small" @click.stop="showInput">+ 新选项</el-button>

                </el-form-item>
            </div>
            <div style="margin-left: 10px;text-align: center">
                <el-form-item>
                    <el-button type="success" @click.stop="submitConfig">保存</el-button>
                    <el-button  @click.stop="cancelEdit">取消</el-button>
                </el-form-item>
            </div>
        </el-form>
        <el-dialog :title="nowData.title" :visible.sync="dialogTip" width="420px">
            <el-form :inline="dialogTip">
                <el-form-item  label="填写提示">
                    <el-input v-model="nowData.describe" autocomplete="off" style="width: 300px"></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click.stop="dialogTip = false">取 消</el-button>
                <el-button type="primary" @click.stop="()=>handleSubmit()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        props: ["editOne", 'uuid'],
        created() {
            this.editName = this.uuid
        },
      computed: {
        getName: function () {
          return this.editOne.uuid
        }
      },
        watch: {
            getName: {
                handler(newName) {
                    if (!newName || this.uuid === newName) {
                        this.initData()
                    }
                }
            }
        },
        data() {
            return {
                dialogTip: false,
                editName: "",
                nowData: {},
                dynamicTags: ['标签一', '标签二'],
                inputVisible: false,
                inputValue: ''
            }
        },
        methods: {
            handleSubmit(){
                this.dialogTip = false
            },
            initData() {
                if (this.editOne.uuid) {
                    let data = JSON.parse(JSON.stringify(this.editOne))
                    // data.describe =JSON.stringify(data.describe) != '{}'? data.describe: ""
                    this.nowData = data
                    this.dynamicTags = JSON.stringify(data.data) != '[]' ? data.data : ['标签一', '标签二']
                } else {
                    this.nowData = {}
                }
            },
            handleClose(tag) {
                this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
            },

            showInput() {
                this.inputVisible = true;
                this.$nextTick(() => {
                    this.$refs.saveTagInput.$refs.input.focus();
                });
            },

            handleInputConfirm() {
                let inputValue = this.inputValue;
                if (inputValue) {
                    this.dynamicTags.push(inputValue);
                }
                this.inputVisible = false;
                this.inputValue = '';
            },
            cancelEdit(){
                this.$emit("cancelDo",this.nowData )
            },
            submitConfig() {
                let data = JSON.parse(JSON.stringify(this.nowData))
                data.data = JSON.stringify(this.dynamicTags)
                this.$emit('editForm', data)
            }
        }
    }
</script>
<style>
    .nowData {
        background-color: #ddd;
    }

    .nowData>.el-form-item {
        margin: 10px;
        cursor: pointer;
    }

    .el-tag+.el-tag {
        margin-left: 10px;
    }

    .button-new-tag {
        margin-left: 10px;
        height: 32px;
        line-height: 30px;
        padding-top: 0;
        padding-bottom: 0;
    }

    .input-new-tag {
        width: 90px;
        margin-left: 10px;
        vertical-align: bottom;
    }
</style>